<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-select v-model="lb_value" placeholder="请选择" size="small" filterable clearable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="anchor_name" label="主播昵称"></el-table-column>
				<el-table-column prop="name" label="标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="content" label="封面">
					<template slot-scope="scope">
						<div class="u-f u-wrap" v-if="scope.row.feedsImgUrl">
							<img :src="scope.row.feedsImgUrl" alt="" width="50" class="tablimg"
								@click="goprev(scope.row.feedsImgUrl)">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="直播时间" show-overflow-tooltip>
					<template slot-scope="scope">
						{{date('Y-m-d H:i:s',scope.row.start_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="live_num" label="直播状态" show-overflow-tooltip></el-table-column>
				<el-table-column prop="liveType" label="直播分类" show-overflow-tooltip></el-table-column>
				<el-table-column prop="liveType" label="展示" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({0:'全部',1:'公众号',2:'小程序'})[scope.row.is_show]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="fee" label="费用" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="展示设置" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="标题" prop='title_value'>
						<el-input v-model="ruleForm.title_value" size="small"></el-input>
					</el-form-item>
					<el-form-item label="直播昵称" prop='nc_value'>
						<el-input v-model="ruleForm.nc_value" size="small"></el-input>
					</el-form-item>
					<el-form-item label="开始时间" prop='nc_value'>
						<el-date-picker v-model="ruleForm.start_time" size="small" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间" prop='nc_value'>
						<el-date-picker v-model="ruleForm.end_time" size="small" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="直播分类" prop='zbfl_value'>
						<el-select v-model="ruleForm.zbfl_value" placeholder="请选择" size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-row>
						<el-col :span="8">
							<el-form-item label="分享封面" required>
								<el-upload class="avatar-uploader" action="/admin/getMediaId" name="media" ref="upload"
									:headers="{ token:$store.state.user.token }" :limit="1"
									:file-list="ruleForm.fx_mapList" :on-success="uploadSuccess_fx"
									:on-remove="uploadRmove_fx" list-type="picture-card">
									<i class="el-icon-plus"></i>
									<!-- verification:1,fileS:2,fileH:300,fileW:300  -->
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="直播封面" required>
								<el-upload class="avatar-uploader" action="/admin/getMediaId" name="media" ref="upload"
									:headers="{ token:$store.state.user.token }" :limit="1"
									:file-list="ruleForm.zb_mapList" :on-success="uploadSuccess_zb"
									:on-remove="uploadRmove_zb" list-type="picture-card">
									<i class="el-icon-plus"></i>
									<!-- verification:1,fileS:2,fileH:300,fileW:300  -->
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="背景墙" required>
								<el-upload class="avatar-uploader" action="/admin/getMediaId" name="media" ref="upload"
									:headers="{ token:$store.state.user.token }" :limit="1"
									:file-list="ruleForm.bj_mapList" :on-success="uploadSuccess_bj"
									:on-remove="uploadRmove_bj" list-type="picture-card">
									<i class="el-icon-plus"></i>
									<!-- verification:1,fileS:2,fileH:300,fileW:300  -->
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="直播详情">
						<tinymce ref="editor" v-model="ruleForm.lb_content"
							toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
					</el-form-item>
					<el-form-item label="展示">
						<el-select v-model="ruleForm.show_state" placeholder="请选择" size="small">
							<el-option v-for="item in show_options" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="展示用户">
						<el-select v-model="ruleForm.audience_type" placeholder="请选择" size="small">
							<el-option v-for="item in show_user_options" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>

				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<!--  -->
		<el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="urls" class="w-100" />
			</div>
		</el-dialog>



	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			tinymce,
			comment
		},
		data() {
			return {
				date: xaoi.date,
				lb_value: '',
				lb_options: [{
						id: 1,
						name: '学术峰会'
					},
					{
						id: 2,
						name: '名医直播'
					},
					{
						id: 3,
						name: '性功能障碍'
					},
					{
						id: 4,
						name: '前列腺疾病'
					},
					{
						id: 5,
						name: '生殖感染'
					},
					{
						id: 6,
						name: '生殖整形'
					},
					{
						id: 7,
						name: '泌尿结石'
					},
					{
						id: 8,
						name: '男性更年期'
					},
					{
						id: 9,
						name: '中医男科'
					},
					{
						id: 10,
						name: '男性不育'
					}
				],
				show_options: [{
						id: 0,
						name: '全部'
					},
					{
						id: 1,
						name: '公众号'
					}, {
						id: 2,
						name: '小程序'
					},
				],
				show_user_options: [{
						id: 0,
						name: '全部'
					},
					{
						id: 1,
						name: '用户'
					}, {
						id: 2,
						name: '医生'
					},
				],
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,

				ruleForm: {
					show_state: '',
					lb_content: '',
					bj_mapList: [],
					zb_mapList: [],
					fx_mapList: [],
					zbfl_value: '',
					nc_value: '',
					title_value: '',
					end_time: '',
					start_time: '',
					audience_type:''
				},
				mapListed_bj: [],
				mapListed_zb: [],
				mapListed_fx: [],
				rule: {
					zbfl_value: [{
						required: true,
						message: '请填写分类',
						trigger: 'blur'
					}],
					title_value: [{
						required: true,
						message: '请填写标题',
						trigger: 'blur'
					}],

					nc_value: [{
						required: true,
						message: '请填写主播昵称',
						trigger: 'blur'
					}],

				},
				// 
				dialog_prev: false,
				urls: '',
				// 
				dialogs: false,
				rows: '',

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/KkysLiveRoom/MliveList", {
						page: that.currentPage,
						page_count: that.pagesize,
						is_show: '',
						live_type: that.lb_value
					}, {
						token: true
					})
					.then(response => {

						that.loading = false
						that.tableData = response.data.data.room_info
						that.count = response.data.data.total
						this.tableData.forEach((item) => {
							item.live_num = this.statusNum(item.live_status);
							item.liveType = this.typeNum(item.live_type);
						})
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			// 状态码
			statusNum(num) {
				var val = '';
				switch (num) {
					case 101:
						val = '直播中';
						break;
					case 102:
						val = '未开始';
						break;
					case 103:
						val = '已结束';
						break;
					case 104:
						val = '禁播';
						break;
					case 105:
						val = '暂停';
						break;
					case 106:
						val = '异常';
						break;
					case 107:
						val = '已过期';
						break;
				}
				return val;
			},
			// 内容类型
			typeNum(num) {
				var val = '';
				switch (num) {
					case 1:
						val = '学术峰会';
						break;
					case 2:
						val = '名医直播';
						break;
					case 3:
						val = '性功能障碍';
						break;
					case 4:
						val = '前列腺疾病';
						break;
					case 5:
						val = '生殖感染';
						break;
					case 6:
						val = '生殖整形';
						break;
					case 7:
						val = '泌尿结石';
						break;
					case 8:
						val = '男性更年期';
						break;
					case 9:
						val = '中医男科';
						break;
					case 10:
						val = '男性不育';
						break;
				}
				return val;
			},
			form_clear() {
				let that = this
				this.ruleForm.show_state = ''
				this.ruleForm.lb_content = ''
				this.ruleForm.bj_mapList = []
				this.mapListed_bj = []
				this.ruleForm.zb_mapList = []
				this.mapListed_zb = []
				this.ruleForm.fx_mapList = []
				this.mapListed_fx = []
				this.ruleForm.zbfl_value = ''
				this.ruleForm.nc_value = ''
				this.ruleForm.title_value = ''
				that.mapListed = []
			},

			submit(formName) {
				let that = this
				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.mapListed_bj.length < 1) return that.$message.error('请上传直播背景图');
						if (that.mapListed_zb.length < 1) return that.$message.error('请上传直播封面');
						if (that.mapListed_fx.length < 1) return that.$message.error('请上传分享封面');
						that.subloading = true
						let urls = "/admin/editLive"
						axios.post(urls, {
								id: that.eid,
								anchorName: this.ruleForm.nc_value, // 主播昵称
								anchorWechat: this.rows.anchorWechat, // 主播微信号
								closeLike: this.rows.close_like, // 是否关闭点赞 1：关闭
								closeGoods: this.rows.close_goods, // 是否关闭商品货架，1：关闭
								closeComment: this.rows.close_comment, // 是否开启评论，1：关闭
								closeReplay: this.rows.close_replay, // 是否关闭回放 1 关闭
								// closeShare:'', //  是否关闭分享 1 关闭
								// closeKf: 1, // 是否关闭客服，1 关闭
								name: this.ruleForm.title_value, // 房间名字
								startTime: this.ruleForm.start_time, // 开始时间
								endTime: this.ruleForm.end_time, // 结束时间
								subAnchorWechat: '', // 主播副号微信号
								createrWechat: '', // 创建者微信号
								shareImg: this.mapListed_fx[0].media_id, //通过 uploadfile 上传，填写 mediaID
								shareImgUrl: this.mapListed_fx[0].url,
								feedsImg: this.mapListed_zb[0].media_id, //通过 uploadfile 上传，填写 mediaID
								feedsImgUrl: this.mapListed_zb[0].url,
								coverImg: this.mapListed_bj[0].media_id, // 通过 uploadfile 上传，填写 mediaID
								coverImgUrl: this.mapListed_bj[0].url,
								isFeedsPublic: this.rows.is_feeds_public, // 是否开启官方收录，1 开启，0 关闭
								type: this.rows.type, // 直播类型，1 推流 0 手机直播
								fee: this.rows.fee,
								live_type: this.ruleForm.zbfl_value,
								is_show: this.ruleForm.show_state,
								live_detail: this.ruleForm.lb_content,
								audience_type: this.ruleForm.audience_type,
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				this.rows = row
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.roomId


				this.ruleForm.show_state = row.is_show
				this.ruleForm.lb_content = row.live_detail ? row.live_detail : ''

				this.ruleForm.zbfl_value = row.live_type
				this.ruleForm.nc_value = row.anchor_name
				this.ruleForm.title_value = row.name
				this.ruleForm.start_time = row.start_time
				this.ruleForm.end_time = row.end_time
				this.ruleForm.audience_type = row.audience_type
				let obj_fx = [{
					media_id: row.shareImg,
					url: row.shareImgUrl
				}]
				let obj_zb = [{
					media_id: row.feedsImg,
					url: row.feedsImgUrl
				}]
				let obj_bj = [{
					media_id: row.coverImg,
					url: row.coverImgUrl
				}]
				this.mapListed_fx = obj_fx
				this.ruleForm.fx_mapList = obj_fx

				this.mapListed_zb = obj_zb
				this.ruleForm.zb_mapList = obj_zb

				this.mapListed_bj = obj_bj
				this.ruleForm.bj_mapList = obj_bj


			},
			// 删除
			handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该直播, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/delLive", {
							id: row.roomId,
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.msg);
							}
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},


			goprev(item) {
				let that = this
				that.dialog_prev = true
				that.urls = item
			},
			// 分享封面
			uploadSuccess_fx(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed_fx.push(response.data)
			},
			uploadRmove_fx(file, fileList) {
				var index = this.mapListed_fx.findIndex(item => item.id == file.id)
				this.mapListed_fx.splice(index, 1)
			},
			// 直播封面
			uploadSuccess_zb(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed_zb.push(response.data)
			},
			uploadRmove_zb(file, fileList) {
				var index = this.mapListed_zb.findIndex(item => item.id == file.id)
				this.mapListed_zb.splice(index, 1)
			},
			// 背景封面
			uploadSuccess_bj(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed_bj.push(response.data)
			},
			uploadRmove_bj(file, fileList) {
				var index = this.mapListed_bj.findIndex(item => item.id == file.id)
				this.mapListed_bj.splice(index, 1)
			},
		},
		watch: {

		}

	};
</script>


<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tablimg {
		margin: 2px 5px;
	}

	.con_b {
		height: 500px;
		overflow-x: auto;
		border: 1px solid rgb(206, 206, 206);
		border-radius: 5px;
	}
</style>